// extracted by mini-css-extract-plugin
export default {"description":"RegisterFailed_description__YR+3I","button":"RegisterFailed_button__k2C9r"};